import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      Enviis Unu al la Deko: «Nu certe, kun tiu ŝika rondiĝo ankaŭ mi aspektus impone!»
    </p>
    
    <p class="mb-3">
      Tial, kiam ŝi sukcesis iel akiri unu Nulon, ŝi ne metis lin post si, kiel la Deko, sed starigis antaŭe – por ke ĉiuj vidu!
    </p>
    
    <p class="mb-3">
      Rezultiĝis vere bele: 0,1.
    </p>
    
    <p class="mb-3">
      Poste, ŝi ankoraŭ unu Nulon alproprigis. 
      Kaj same metis lin antaŭen: rigardu, jen kiaj ni estas!
    </p>
    
    <p class="mb-3">
      0,01.
    </p>
    
    <p class="mb-3">
      Ekplaĉis tio al Unu, kaj komencis ŝi kolektadi Nulojn, akirante ilin per la tutaj fortoj, ĉu per justaj aŭ nejustaj rimedoj – ne gravas!
    </p>
    
    <p class="mb-3">
      Kaj nun oni eĉ ne ekkonus la iaman Unu: tiom grava kaj plensignifa ŝi estas. 
    </p>
    
    <p class="mb-3">
      Pritaksu vi mem: 0,00000000001.
    </p>
    
    <p class="mb-3">
      Jen kiun grandecon ŝi atingis!
    </p>
    `
  )
}

const itemName = {
  esp: 'La grandeco'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;